export const CUSTOMER_ONBOARDING_CONSTANTS = {
  // Titles and Headers
  MODULE_TITLE: "Customer Onboarding",
  CUSTOMER_TAB_TITLE: "Customers",
  AUDIT_LOG_TAB_TITLE: "Audit Log",
  EXPORT_BUTTON_LABEL: "Export",

  // Add customer flow
  ADD_CUSTOMER_BUTTON_LABEL: "Add Customer",
  ADD_CUSTOMER_MODAL_TITLE: "Customer Onboarding", // Reused for adding
  CUSTOMER_CREATED_TITLE: "Customer Added",
  ADD_PRODUCT_LINE_INJECTORS_BUTTON_LABEL: "Add Product Line & Injectors",
  ADD_ANOTHER_CUSTOMER_BUTTON_LABEL: "Add Another Customer",
  ADD_INJECTORS_MODAL_TITLE: "Add Injectors",
  ADD_INJECTORS_BUTTON_LABEL: "Add Injectors",
  INJECTORS_ADDED_TITLE: "Injector Added",

  // Edit customer flow
  EDIT_CUSTOMER_MODAL_TITLE: "Edit Customer",
  CUSTOMER_EDITED_TITLE: "Customer Edited",
  INJECTORS_EDITED_TITLE: "Injector Edited",
  EDIT_INJECTORS_MODAL_TITLE: "Edit Injectors",

  BACK_TO_CUSTOMER_LISTING: "Back To Customer Listing",
  EDIT_BUTTON_LABEL: "Edit",
  REMOVE_BUTTON_LABEL: "Remove",
  VIEW_BUTTON_LABEL: "View",
  CHANGE_EXPIRY_DATE_BUTTON_LABEL: "Change Expiry Date",
  ASSIGN_BUTTON_LABEL: "Assign",
  TRANSFER_BUTTON_LABEL: "Transfer",
  ASSIGN_ROLE_BUTTON_LABEL: "Assign Role",
  NO_INJECTORS_FOUND: "No Injectors Found",
  NO_INJECTORS_ADDED: "No Injectors Added",
  SAVE_BUTTON_LABEL: "Save",
  CONTINUE_BUTTON_LABEL: "Continue",
  CANCEL_BUTTON_LABEL: "Cancel",
  CLOSE_BUTTON_LABEL: "Close",
  SUBMIT_BUTTON_LABEL: "Submit",
  DONE_BUTTON_LABEL: "Done",

  // Messages
  LOGIN_SUCCESS_MESSAGE: "Login successful!",
  SESSION_EXPIRED_DETAIL: "You have been logged out.",
  PASSWORD_RESET_TOKEN_MISSING: "Password reset token is missing.",
  FORM_CORRECTION_WARNING: "Please correct the form errors.",
  NEW_CUSTOMER_ADDED_SUCCESS: "New Customer Added Successfully",
  CUSTOMER_EDITED_SUCCESS: "Customer Edited Successfully",
  INJECTORS_ADDED_SUCCESS: "Injector Added Successfully",
  INJECTORS_EDITED_SUCCESS: "Injector Edited successfully",
  CUSTOMER_DETAILS_UPDATED_SUCCESS: "Customer Details Updated Successfully",
  FILL_ALL_REQUIRED_INJECTOR_FIELDS:
    "Please fill all required fields for the injector.",
  ADD_AT_LEAST_ONE_INJECTOR: "Please add at least one injector to continue.",
  NO_MATCHING_RECORDS_FOUND: "No matching records found.",

  // Table Headers (Customer Onboarding Component)
  TABLE_HEADER_SNO: "S.No",
  TABLE_HEADER_PARENT_CUSTOMER_NAME: "Parent Customer Name",
  TABLE_HEADER_ACCOUNT_SMG_NUMBER: "Account SMG Number",
  TABLE_HEADER_CUSTOMER_NAME: "Customer Name",
  TABLE_HEADER_CUSTOMER_LOCATION: "Customer Location",
  TABLE_HEADER_CUSTOMER_SAP_NUMBER: "Customer SAP Number",
  TABLE_HEADER_ACTION: "Action",
  TABLE_HEADER_USER_NAME: "User Name",
  TABLE_HEADER_EMAIL_ID: "Email Id",
  TABLE_HEADER_ROLE_TYPE: "Role Type",
  TABLE_HEADER_TIMESTAMP: "Timestamp",

  // Table Headers (Customer Listing Component - Injectors)
  TABLE_HEADER_PRODUCT_LINE: "Product Line",
  TABLE_HEADER_PRODUCT_MODALITY: "Product Modality",
  TABLE_HEADER_SRU_SERIAL_NUMBER: "SRU Serial Number",
  TABLE_HEADER_CRU_SERIAL_NUMBER: "CRU Serial Number",
  TABLE_HEADER_INJECTOR_ID: "Injector ID",
  TABLE_HEADER_PASSLINK_SYSTEM_ID: "Passlink System ID",
  TABLE_HEADER_MASTER_ASSET_NUMBER: "Master Asset Number",
  TABLE_HEADER_CONTRACT_NAME: "Contract Name",
  TABLE_HEADER_CONTRACT_EXPIRY_DATE: "Contract Expiry Date",
  TABLE_HEADER_ACTIONS: "Actions",

  // Form Labels (Edit Customer Component)
  FORM_LABEL_PARENT_CUSTOMER_NAME: "Parent Customer Name",
  FORM_LABEL_ACCOUNT_SMG_NUMBER: "Account SMG Number",
  FORM_LABEL_CUSTOMER_NAME: "Customer Name",
  FORM_LABEL_CUSTOMER_LOCATION: "Customer Location",
  FORM_LABEL_CUSTOMER_SAP_NUMBER: "Customer SAP Number",

  // Form Labels (Add/Edit Injectors Component)
  FORM_LABEL_PRODUCT_LINE: "Product Line",
  FORM_LABEL_PRODUCT_MODALITY: "Product Modality",
  FORM_LABEL_SRU_SERIAL_NUMBER: "SRU Serial Number",
  FORM_LABEL_CRU_SERIAL_NUMBER: "CRU Serial Number",
  FORM_LABEL_INJECTOR_ID: "Injector ID",
  FORM_LABEL_PASSLINKSYSTEM_ID: "PassLink System ID",
  FORM_LABEL_MASTER_ASSET_NUMBER: "Master Asset Number",
  FORM_LABEL_CONTRACT_NAME: "Contract Name",
  FORM_LABEL_CONTRACT_EXPIRY_DATE: "Contract Expiry Date",

  // Placeholders
  PLACEHOLDER_SELECT: "Select",
  PLACEHOLDER_DATE: "Date",
  PLACEHOLDER_ENTER_TEXT: "Enter text...",
  PLACEHOLDER_SEARCH: "Search...",
  PLACEHOLDER_PARENT_CUSTOMER_NAME: "Parent Customer Name",
  PLACEHOLDER_ACCOUNT_SMG_NUMBER: "Account SMG Number",
  PLACEHOLDER_CUSTOMER_NAME: "Customer Name",
  PLACEHOLDER_CUSTOMER_SAP_NUMBER: "Customer SAP Number",
  PLACEHOLDER_SRU_SERIAL_NUMBER: "SRU Serial Number",
  PLACEHOLDER_CRU_SERIAL_NUMBER: "CRU Serial Number",
  PLACEHOLDER_INJECTOR_ID: "Injector ID",
  PLACEHOLDER_PASSLINKSYSTEM_ID: "PassLink System ID",
  PLACEHOLDER_MASTER_ASSET_NUMBER: "Master Asset Number",
  PLACEHOLDER_CONTRACT_NAME: "Contract Name",

  // Routes
  ROUTE_CUSTOMER_ONBOARDING: "/customer-onboarding",
  ROUTE_CUSTOMER_LISTING: "/customer-listing", // Base route, needs :sno appended
  ROUTE_HOME: "/home",
  ROUTE_LOGIN: "/login",

  // Numbers/Counts
  TABLE_ROWS_DEFAULT: 10,
  TABLE_ROWS_INJECTORS: 3,

  // Other
  DATE_FORMAT: "dd/mm/yy",
  DATE_FORMAT_EDIT_INJECTOR: "dd M, yy",
  GLOBAL_FILTER_CONTAINS: "contains",
};

// Re-export all constants from a single entry point
export * from "./constants";
